"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CopyableLink = require("./CopyableLink");
Object.keys(_CopyableLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CopyableLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CopyableLink[key];
    }
  });
});